import React from "react";
import * as Mui from "@mui/material";
import { IntegrationType } from "type/integration-type";
import { AddButton } from "../add-button";

interface Props {
	integrationType: IntegrationType;
	onClose: Function;
}

class Component extends React.Component<Props> {

	public render() {
		const { integrationType, onClose } = this.props;
		return (
			<Mui.Grid container direction="column" spacing={2}>
				<Mui.Grid item>
					<Mui.Typography>Sends real-time lead and visitor activity events (listing views, searches, form submissions, and more) as signed JSON to an HTTPS URL of your choosing. Configure the URL and signing secret after adding.</Mui.Typography>
				</Mui.Grid>
				<Mui.Grid item>
					<AddButton integrationType={integrationType} onClose={onClose} />
				</Mui.Grid>
			</Mui.Grid>
		);
	}

}

export const ClientEventWebhookIntegration = Component;
